import { FlexGrid, FlexGridColumn } from '../../components/FlexGrid';
import { Authentication } from './Authentication';
import { gray } from '../../components/Color';

function AuthenticationLoginPage() {
	return (
		<FlexGrid
			center
			style={{
				flex: '1 1 auto',
				backgroundColor: gray[0],
			}}
		>
			<FlexGridColumn grow>
				<Authentication />
			</FlexGridColumn>
		</FlexGrid>
	);
}

export { AuthenticationLoginPage };
